import axios from "axios";

import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import Divider from "@mui/material/Divider";

import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import EmailIcon from "@mui/icons-material/Email";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./styles.css";

import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";

import circlesBg from "../../assets/backgrounds/circles-bg.png";
import { ReactComponent as Logo } from "../../assets/logo/DARK_LOGO.svg";

import Config from "../../config.js";

import { useAuth } from "../../contexts/AuthContext.js";

import models from "../../assets/backgrounds/models.png";

export default function Login() {
  document.title = "Entrar | Ginastee";

  const navigation = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const [email, setEmail] = useState(Window.signInForm_1_email || "");
  const [password, setPassword] = useState(Window.signInForm_1_password || "");
  const [formRequirements, setFormRequirements] = useState(
    Window.signInForm_1_formRequirements || {
      emailValid: false,
      charactersNumber: false,
      atLeastACapitalLetter: false,
      lettersAndNumbers: false,
    }
  );

  const { login } = useAuth();

  useEffect(handleEmailValidation, [email]);
  useEffect(handlePasswordValidation, [password]);

  function handleEmailValidation() {
    const newFormRequirements = { ...formRequirements };
    newFormRequirements.emailValid =
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    Window.signInForm_1_formRequirements = newFormRequirements;
    setFormRequirements({ ...newFormRequirements });
  }
  function handlePasswordValidation() {
    const newFormRequirements = { ...formRequirements };
    newFormRequirements.charactersNumber =
      password.replaceAll(" ", "").length >= 8;
    newFormRequirements.atLeastACapitalLetter = /[a-z]/.test(password);
    newFormRequirements.lettersAndNumbers =
      /^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$)/.test(password) &&
      password.replaceAll(" ", "").length >= 2;

    Window.signInForm_1_formRequirements = newFormRequirements;
    setFormRequirements({ ...newFormRequirements });
  }

  async function handleLogin(e) {
    e?.preventDefault();
    setIsLoading(true);
    const result = await login(email, password);
    if (!result) {
      setErrorMessage("Email ou senha incorretos");
    } else {
      window.location.href = "/";
    }
    setIsLoading(false);
  }

  return (
    <div className="page">
      <div className="form-area px-4 py-5">
        <Logo className="header-logo" />

        <Typography variant="h3" component="h3" className="mb-1 mt-4 center ">
          Você está a um passo de ter sua própria comunidade
        </Typography>

        <Typography variant="h5" component="h5" className="center mt-3">
          Seja bem vindo(a), para continuar, faça login, ou crie uma nova conta
        </Typography>
        <form
          id="login-form"
          onSubmit={handleLogin}
          className="signin-form mt-3"
        >
          <TextField
            fullWidth
            label="Seu email"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
            disabled={isLoading}
            placeholder="seu@email.com"
            variant="outlined"
            color="primary"
            autoFocus
            onInput={(v) => {
              Window.signInForm_1_email = v.target.value;
              setEmail(v.target.value);
            }}
            value={email}
            id="email-field"
            className=""
            style={{ animationDelay: "0.2s" }}
          />

          <TextField
            fullWidth
            label="Senha"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <VpnKeyIcon />
                </InputAdornment>
              ),
            }}
            disabled={isLoading}
            placeholder="********"
            variant="outlined"
            color="primary"
            onInput={(v) => {
              Window.signInForm_1_password = v.target.value;
              setPassword(v.target.value);
            }}
            value={password}
            id="password-field"
            type="password"
            className=" mt-2"
            style={{ animationDelay: "0.3s" }}
          />

          <Stack sx={{ width: "100%" }} spacing={2}>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
          </Stack>

          <Button
            variant="contained"
            disabled={isLoading}
            color="primary"
            sx={{ mt: 2 }}
            startIcon={isLoading ? null : <ArrowForwardIosIcon />}
            type="submit"
            style={{ animationDelay: "0.4s" }}
            className=" px-1 py-2"
          >
            {isLoading ? (
              <CircularProgress style={{ width: 26, height: 26 }} />
            ) : (
              "Entrar no sistema"
            )}
          </Button>
          <Divider className="mt-3 mb-1">
            <Typography variant="h5" component="h5">
              ou, crie uma nova conta
            </Typography>
          </Divider>

          <Button
            variant="outlined"
            onClick={handleLogin}
            color="primary"
            type="button"
            onClick={() => navigation("/signin")}
            className=""
            style={{ animationDelay: "0.6s", position: "relative", bottom: 0 }}
          >
            Se cadastrar
          </Button>
        </form>
      </div>
      <img src={circlesBg} className="page-bg" />
    </div>
  );
}
